import styled from "styled-components";

export const StyledWrapper = styled.div`
  .page-timestamp {
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.InterfaceCopySmallItalic}
    text-align: right;
  }
`;
